export default __webpack_public_path__ + "static/media/Left_Arrow.304a14f5.svg";